// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"SiteSettings_mainContent__2nwJb","emailList":"SiteSettings_emailList__udYFX","deleteEmail":"SiteSettings_deleteEmail__hhvhO"};